<template>
  <Slideout
    title="Edit Item"
    @closeSlideout="handleClose"
  >
    <div class="pros-collection-br-drawer">
      <ProductThumbnail
        v-if="editedProduct"
        :key="editedProduct.id"
        :product="editedProduct"
        :show-wish-list-btn-on-image="true"
        click-action="linkToPdp"
        :url-template="localImageSrc"
        :is-large-card="true"
        review-link="#"
        :slideshow-props="{
          useSlideshow: true,
          showIndicator: true,
          autoplayMode: 'manual',
          backToFirst: false,
        }"
        :open-in-new-tab="openInNewTab"
        @updateSelectedSize="updateSelectedMemberProduct"
        @updateUpcId="handleUpdateUpcId"
      />
      <div class="edit-drawer-footer">
        <button
          id="edit-drawer-update-item"
          class="button primary"
          @click="updateItem"
        >
          Update Item
        </button>
        <a
          id="edit-drawer-view-product-details"
          :href="productUrl"
          title="View Full Product Details"
        >
          View Full Product Details
        </a>
      </div>
    </div>
  </Slideout>
</template>

<script>
import { Slideout } from '@atomic-ui/slideout';
import { ProductThumbnail } from '@common-vue/product-thumbnail';

export default {
  name: 'EditItemDrawer',
  components: { Slideout, ProductThumbnail },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    openInNewTab: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update-item', 'close-slideout'],
  data() {
    return {
      selectedMemberProductIndex: this.product?.traits?.sizes?.selectedSize,
      editedProduct: this.product,
    };
  },
  computed: {
    localImageSrc() {
      return this.editedProduct?.urlTemplate;
    },
    productUrl() {
      return this.editedProduct?.identifier?.productUrl;
    },
  },
  watch: {
    product(val) {
      this.editedProduct = val;
    },
  },
  mounted() {
  },
  methods: {
    updateItem() {
      this.$emit('update-item', this.editedProduct.identifier.productId, this.selectedMemberProductIndex);
    },
    updateSelectedMemberProduct(size) {
      const { id: productIndex } = size;
      this.selectedMemberProductIndex = productIndex;

      const upcToUse = this.editedProduct.relationships.memberProductIds[productIndex];
      const selectedProduct = this.editedProduct.relationships.memberProductMap[upcToUse];

      this.editedProduct.detail.name = selectedProduct.detail.name;
    },
    handleUpdateUpcId() {
      // update id logic should go here
    },
    handleClose() {
      this.$emit('close-slideout');
    },
  },
};
</script>

<style scoped lang="scss">
.pros-collection-br-drawer .edit-drawer-footer{
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 1rem;

  button {
    width: 100%;
    padding: 1rem 1.25rem;
  }
}
</style>
